module.exports = __webpack_public_path__ + "static/submarine-df6c9a8003a48650eb02b3bb3b34edbf.png";